import { render, staticRenderFns } from "./articledetails.vue?vue&type=template&id=6acd6752&"
import script from "./articledetails.vue?vue&type=script&lang=js&"
export * from "./articledetails.vue?vue&type=script&lang=js&"
import style0 from "./articledetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports